import { loadStripe } from '@stripe/stripe-js';

export let stripe;
export const stripePromise = loadStripe(__STRIPE_KEY__);

export async function initPayment() {

  // console.log("Payment initiated");

  stripe = await stripePromise;
}